import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login'
import Index from '../views/Index'

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        component: Login
    },
    {
        path: '/modifypass',
        component: () => import('../views/ModifyPass')
    },
    {
        path: '/ssoredirect/:code',
        component: () => import('../views/SsoRedirect.vue')
    },
    {
        path: '/',
        component: Index,
        children: [
            {path: 'downlogs', component: () => import('../views/page/DownLogs')},
            {path: 'uplogs', component: () => import('../views/page/UpLogs')},
            {path: 'customers', component: () => import('../views/page/Customers')},
            {path: 'customer/:id', component: () => import('../views/page/Customer')},
            {path: 'businesses', component: () => import('../views/page/Businesses')},
            {path: 'business/:id', component: () => import('../views/page/Business')},
            {path: 'channels', component: () => import('../views/page/Channels')},
            {path: 'channel/:id', component: () => import('../views/page/Channel')},
            {path: 'blacklist', component: () => import('../views/page/BlackList')},
            {path: 'blacklist/import', component: () => import('../views/page/BlackListImport')},
            {path: 'blacklist/:id', component: () => import('../views/page/BlackListEdit')},
            {path: 'sensitives', component: () => import('../views/page/Sensitives')},
            {path: 'sensitives/:id', component: () => import('../views/page/SensitiveWord')},
            {path: 'routes', component: () => import('../views/page/Routes')},
            {path: 'route/:id', component: () => import('../views/page/Route')},
            {path: 'summary', component: () => import('../views/page/Summary')},
            {path: 'jobsummary', component: () => import('../views/page/JobSummary')},
            {path: 'monitor', component: () => import('../views/page/Monitor')},
            {path: 'test', component: () => import('../views/page/Test')},
            {path: 'downloads', component: () => import('../views/page/Downloads')},
            {path: 'templates', component: () => import('../views/page/Templates')},
            {path: 'template/:id', component: () => import('../views/page/Template')},
            {path: 'jobs', component: () => import('../views/page/Jobs')},
            {path: 'job/:id', component: () => import('../views/page/Job')},
            {path: 'jobdetail/:id', component: () => import('../views/page/JobDetail')},
            {path: 'autoreplies', component: () => import('../views/page/AutoReplies')},
            {path: 'autoreply/:id', component: () => import('../views/page/AutoReply')},
            {path: 'namelist', component: () => import('../views/page/namelist/Index')},
            {path: 'namelist/:id', component: () => import('../views/page/namelist/Config')},
            {path: 'channelsummary', component: () => import('../views/page/ChannelSummary')},
            {path: 'pushreport', component: () => import('../views/page/PushReport')},
            {path: 'rates', component: () => import('../views/page/rate/Index')},
            {path: 'rate/:id', component: () => import('../views/page/rate/Config')},
            {path: 'rateglobal', component: () => import('../views/page/rate/ConfigGlobal')},
        ]
    },
    {
        path: '/mms',
        component: Index,
        children: [
            {path: 'templates', component: () => import('../views/mms/Templates')},
            {path: 'template/:id', component: () => import('../views/mms/Template')},
            {path: 'jobs', component: () => import('../views/mms/Jobs')},
            {path: 'job/:id', component: () => import('../views/mms/Job')},
            {path: 'logs', component: () => import('../views/mms/Logs')},
            {path: 'jobsummary', component: () => import('../views/mms/JobSummary')},
            {path: 'logsCount', component: () => import('../views/mms/LogsCount')},
        ]
    },
    {
        path: '/video',
        component: Index,
        children: [
            {path: 'templates', component: () => import('../views/video/Templates')},
            {path: 'template/:id', component: () => import('../views/video/Template')},
            {path: 'jobs', component: () => import('../views/video/Jobs')},
            {path: 'job/:id', component: () => import('../views/video/Job')},
            {path: 'jobsummary', component: () => import('../views/video/JobSummary')},
            {path: 'logs', component: () => import('../views/video/Logs')},
        ]
    },
    {
        path: '/config',
        component: Index,
        children: [
            {path: 'global', component: () => import('../views/page/config/Global')},
            {path: 'price', component: () => import('../views/page/config/Prices')},
            {path: 'price/:id', component: () => import('../views/page/config/Price')},
            {path: 'errorcode', component: () => import('../views/page/config/ErrorCodes')},
            {path: 'errorcode/:id', component: () => import('../views/page/config/ErrorCode')},
        ]
    },
    {
        path: '/isms',
        component: Index,
        children: [
            {path: 'templates', component: () => import('../views/isms/Templates')},
            {path: 'template/:id', component: () => import('../views/isms/Template')},
            {path: 'jobs', component: () => import('../views/isms/Jobs')},
            {path: 'job/:id', component: () => import('../views/isms/Job')},
            {path: 'logs', component: () => import('../views/isms/Logs')},
        ]
    },
    {
        path: '/voice',
        component: Index,
        children: [
            {path: 'templates', component: () => import('../views/voice/Templates')},
            {path: 'template/:id', component: () => import('../views/voice/Template')},
            {path: 'logs', component: () => import('../views/voice/Logs')},
            {path: 'jobs', component: () => import('../views/voice/Jobs')},
            {path: 'job/:id', component: () => import('../views/voice/Job')},
        ]
    },
    {
        path: '/dashboard',
        component: Index,
        children: [
            {path: 'consume', component: () => import('../views/page/dashboard/Consume')},
            {path: 'summary', component: () => import('../views/page/dashboard/Summary')},
        ]
    },
];

const router = new VueRouter({
    routes
});

router.beforeEach(async (to, from, next) => {
    let path = to.path;
    if (path === "/login" || path.startsWith("/ssoredirect")) {
        next();
    } else {
        if (sessionStorage.getItem("context")) {
            next();
        } else {
            next({path: '/login', query: {redirect: to.fullPath}});
        }
    }
});

export default router
